/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegistrationVatConsistencyCouple
 */
export interface RegistrationVatConsistencyCouple {
    /**
     * 
     * @type {string}
     * @memberof RegistrationVatConsistencyCouple
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationVatConsistencyCouple
     */
    vatNumber?: string;
}

/**
 * Check if a given object implements the RegistrationVatConsistencyCouple interface.
 */
export function instanceOfRegistrationVatConsistencyCouple(value: object): value is RegistrationVatConsistencyCouple {
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    return true;
}

export function RegistrationVatConsistencyCoupleFromJSON(json: any): RegistrationVatConsistencyCouple {
    return RegistrationVatConsistencyCoupleFromJSONTyped(json, false);
}

export function RegistrationVatConsistencyCoupleFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationVatConsistencyCouple {
    if (json == null) {
        return json;
    }
    return {
        
        'registrationNumber': json['registrationNumber'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
    };
}

export function RegistrationVatConsistencyCoupleToJSON(value?: RegistrationVatConsistencyCouple | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'registrationNumber': value['registrationNumber'],
        'vatNumber': value['vatNumber'],
    };
}

